// Danger zone for the Configure tab. The confirmation and what it says about
// a delete live in screen-delete-confirm.tsx, shared with the screen tables.

import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import type { Screen } from "@/api/types";
import { DangerZoneSection } from "@/components/danger-zone-section";
import { ScreenDeleteConfirm } from "./screen-delete-confirm";

export interface DeleteScreenCardProps {
    workspaceId: string;
    screen: Screen;
}

export function DeleteScreenCard({ workspaceId, screen }: DeleteScreenCardProps) {
    const navigate = useNavigate();
    const [confirmOpen, setConfirmOpen] = useState(false);

    return (
        <>
            <DangerZoneSection
                description="Permanently deletes the screen and its waiting-time history. Its display URL stops working, so any screen still on it goes dark."
                onDelete={() => setConfirmOpen(true)}
            />
            <ScreenDeleteConfirm
                workspaceId={workspaceId}
                screen={confirmOpen ? screen : null}
                onClose={() => setConfirmOpen(false)}
                onDeleted={() => navigate({ to: "/w/$workspaceId/screens", params: { workspaceId }, replace: true })}
            />
        </>
    );
}
